import React, {useCallback} from 'react'
import Button from '../common/Button'
import {useDispatch} from 'react-redux'
import {ROOT} from '../../routes'

export default function CreateButton() {
  const dispatch = useDispatch()
  const onClick = useCallback(
    () => dispatch({type: ROOT}),
    [dispatch],
  )

  return <Button {...{onClick}}>Send a new game!</Button>
}